import clsx from "clsx";
import { useState } from "react";
import Avatar from "@mui/material/Avatar";
import CmsTextEditorContent from "@Libs/contentful/components/cms-text-editor/CmsTextEditor";
import { LoginPageProps } from "@Types/login-page";
import Link from "@wff/components/Link";
import ForgotPasswordForm from "./forms/ForgotPasswordForm";
import LoginForm from "./forms/LoginForm";
import SignupForm from "./forms/SignupForm";
import classes from "./Login.module.scss";

export const Login = (props: LoginPageProps) => {
  const {
    icon,
    mainPageTitle,
    mainPageSubtitle,
    loginFormSection,
    signupFormSection,
    allBenefitsButtonText,
    allBenefitsButtonUrl,
  } = props;
  const [isPasswordRecoverForm, setIsPasswordRecoverForm] = useState(false);
  const [activeForm, setActiveForm] = useState<"login" | "register">("login");
  const isLoginActive = activeForm === "login";
  const isRegisterActive = activeForm === "register";

  const handleClickOnForgotPassword = () => setIsPasswordRecoverForm(true);
  const handleClickRecoverPasswordCancel = () =>
    setIsPasswordRecoverForm(false);

  return (
    <article className="customer-welcome customer-welcome--login">
      <div className="customer-welcome__header">
        <div className={classes["customer-welcome__image"]}>
          <Avatar
            className={classes["inner-image"]}
            alt={`${icon?.title}`}
            src={`${icon?.url}`}
          />
        </div>
        <h1 className="customer-welcome__title">{mainPageTitle}</h1>
        <div className="customer-welcome__subtitle">
          <CmsTextEditorContent content={mainPageSubtitle} />
        </div>
      </div>
      <main className="customer-welcome__main">
        <div className="customer-welcome__tabs">
          <button
            className={clsx(
              "customer-welcome__tab",
              isLoginActive && "customer-welcome__tab--active"
            )}
            onClick={() => setActiveForm("login")}
          >
            {loginFormSection?.loginFormTitle}
          </button>
          <button
            className={clsx(
              "customer-welcome__tab",
              activeForm === "register" && "customer-welcome__tab--active"
            )}
            onClick={() => setActiveForm("register")}
          >
            {signupFormSection?.signUpFormTitle}
          </button>
        </div>
        <div className="customer-welcome__forms">
          <div
            className={clsx(
              "customer-welcome__form",
              isLoginActive && "customer-welcome__form--active"
            )}
          >
            <section className="customer-login">
              {isPasswordRecoverForm ? (
                <>
                  <h2 className="customer-login__title">
                    {loginFormSection?.loginFormTitle}
                  </h2>
                  <ForgotPasswordForm
                    onClickCancel={handleClickRecoverPasswordCancel}
                    loginFormSection={loginFormSection}
                  />
                </>
              ) : (
                <>
                  <h2 className="customer-register__title">
                    {loginFormSection?.loginFormTitle}
                  </h2>
                  <LoginForm
                    onClickForgotPassword={handleClickOnForgotPassword}
                    loginFormSection={loginFormSection}
                  />
                </>
              )}
            </section>
          </div>

          <div
            className={clsx(
              "customer-welcome__form",
              isRegisterActive && "customer-welcome__form--active"
            )}
          >
            <section className="customer-register">
              <h2 className="customer-register__title">
                {signupFormSection?.signUpFormTitle}
              </h2>
              <SignupForm signupFormSection={signupFormSection} />
            </section>
          </div>
        </div>
        <footer className="customer-welcome__footer">
          <Link
            href={allBenefitsButtonUrl ? allBenefitsButtonUrl : "#"}
            passHref
          >
            <span className="action action--primary--light">
              {allBenefitsButtonText}
            </span>
          </Link>
        </footer>
      </main>
    </article>
  );
};

export default Login;
